import { Skeleton } from "@timeghost/ui/shadcn/skeleton";
import type { JSX } from "react";
import { HOURS_GRID_CLASS } from "@/components/settings/projects/project-hours-table";
import { cn } from "@/lib/utils";

/** Skeleton for project Hours table (range picker stays mounted in panel). */
export default function ProjectHoursLoader({ showToolbar = false }: { readonly showToolbar?: boolean }): JSX.Element {
	return (
		<div aria-busy aria-label="Loading" className="flex min-h-0 flex-1 flex-col gap-3">
			{showToolbar ? (
				<div className="flex flex-wrap items-center gap-2">
					<Skeleton className="h-9 w-56 rounded-md" />
					<Skeleton className="h-4 w-28" />
				</div>
			) : null}
			<div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-lg border border-border">
				<div className={cn(HOURS_GRID_CLASS, "shrink-0 border-border border-b bg-well py-2")}>
					<Skeleton className="h-3 w-20" />
					<Skeleton className="h-3 w-12" />
					<Skeleton className="h-3 w-10" />
					<Skeleton className="h-3 w-12" />
					<Skeleton className="mx-auto h-3 w-14" />
					<Skeleton className="mx-auto h-3 w-14" />
					<div />
				</div>
				{Array.from({ length: 8 }, (_, index) => (
					<div className={cn(HOURS_GRID_CLASS, "border-border border-b last:border-b-0")} key={`hours-skel-${index}`}>
						<div className="flex min-h-12 items-center">
							<Skeleton className="h-4 w-40" />
						</div>
						<div className="flex min-h-12 items-center">
							<Skeleton className="h-4 w-24" />
						</div>
						<div className="flex min-h-12 items-center">
							<Skeleton className="h-4 w-16" />
						</div>
						<div className="flex min-h-12 items-center">
							<Skeleton className="h-4 w-28" />
						</div>
						<div className="flex min-h-12 items-center justify-center">
							<Skeleton className="h-4 w-12" />
						</div>
						<div className="flex min-h-12 items-center justify-center">
							<Skeleton className="size-3.5 rounded-sm" />
						</div>
						<div className="flex min-h-12 items-center">
							<Skeleton className="size-8 rounded-md" />
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
